module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "over"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_over",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("OVERHEARD")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("“My feeling for Mike is something out of the ordinary,” I overhear my aunt say to my mother one day when I am eight years old. “It’s stronger than I am. I cannot explain it. He’s simply the most marvelous child I have ever known, and I love him beyond life itself.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Beyond life itself")]), _vm._v(". At first I feel lucky to be so cherished, singled out to receive a love that is so vast … but then I stop to think about it. I am not sure what it means, really, to be loved "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("beyond life itself")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Do I love my own mother that way? Does she me? Is such a thing even possible?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And why me and not my two younger brothers? What do I have that they do not?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I wish he were mine,” my aunt blurts after a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("From where I am crouching on the stairs in the entry hall, I can feel the weather in the room change. A long, tense pause opens up between the two women. I hear them breathing, back and forth, into that pause.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They are sitting at right angles to each other, I know, my aunt on the sofa, my mother in the chair next to it. This is how they always sit in our living room, not face-to-face but perpendicular, so that they don’t have to make eye contact if they don’t want to.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I wish you had a child of your own,” my mother says carefully. Ever the second fiddle, the third born. The diplomat.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So do I,” says my aunt in a pitched, emotional voice.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Maybe you would be a different person if you did")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My mother does not say this. She thinks it, though. Everybody in our family does. But that’s not what happened.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This is.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83d10556","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/over.vue
// module id = 72
// module chunks = 0